import { render, staticRenderFns } from "./IconHistoric.vue?vue&type=template&id=1e5661bf"
import script from "./IconHistoric.vue?vue&type=script&lang=js"
export * from "./IconHistoric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports